import { useMemo } from 'react';
import { SearchParameters } from 'app/domain';
import { useGallery } from 'app/hooks';
import { LegacyGallery, LegacySearchParameters } from './types';
import { searchParameterAdapter } from './searchParametersAdapter';

const EMPTY_LEGACY: LegacySearchParameters = Object.freeze({});

const useSearchParametersAdapter = (): SearchParameters => {
  const gallery = useGallery() as unknown as LegacyGallery;
  const legacy = gallery?.searchParameters ?? EMPTY_LEGACY;
  return useMemo(() => searchParameterAdapter(legacy), [legacy]);
};

export default useSearchParametersAdapter;
